import {
  Component,
  Input,
  OnInit,ViewChild,ElementRef
} from '@angular/core';

import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-cus-reward-points',
  templateUrl: './cus-reward-points.component.html',
  styleUrls: ['./cus-reward-points.component.scss'],
})
export class CusRewardPointsComponent implements OnInit {
  @Input() customer_id: any;
  loyalty: any;
  page_no = 1;
  scroll_evt = false
  @ViewChild('scrollMe') private myScrollContainer:any = ElementRef;

  constructor(public db:DataService) { }
 
  ngOnInit() {
    this.get_customer_points();
    this.db.Wallet_points = false;
  }

  get_customer_points(){
    var data = {
      customer: this.customer_id.name,
      // customer: this.db.ismobile ? this.customer_id : this.customer_id.name,
      party_type: "Customers"
    }
    this.db.get_customer_points(data).subscribe(res =>{
      console.log("loyalty points",res)
      if(res.message.total_available_points != 0){
          // this.db.payment_bank.loyalty = true;
          this.loyalty = res.message;
          this.get_point_history();
          this.db.Wallet_points = false;
      }
      else{
        this.db.Wallet_points = true;
      }
    })
  }

  get_point_history(){
    let data = {
      customer: this.customer_id.name,
      party_type: 'Customers',
      page_no: this.page_no,
      page_len: 10
    }
    // this.db.get_point_history(data).subscribe(res =>{
    //   console.log("points history",res);
    //   this.loyalty.transactions = res.message
    // })
    this.db.get_point_history(data).subscribe(res=>{ 
      if(this.page_no == 1){
    
        if(res.message && res.message.length != 0){
          this.loyalty.transactions = res.message
          this.scroll_evt = true
        }else{
          this.scroll_evt = false
        }
        
      } else{

        if(res.message && res.message.length != 0){
          res.message.map(r=>{
            this.loyalty.transactions.push(r);
          })
          this.scroll_evt = true
        }else{
          this.scroll_evt = false
        }
        
      }   
    })
  }

  doRefresh(event) {
    // console.log('Begin async operation');
    this.get_customer_points();  
    setTimeout(() => {
      // console.log('Async operation has ended');
      event.target.complete();
    }, 700);
  }

  onScroll(event: any) {
    // console.log(this.scroll_evt)
    // console.log(this.db.inventory_page_no)
     if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight && this.scroll_evt) {
      this.page_no = this.page_no + 1;
       this.get_point_history();
     }
   }

}
